import { RSAA } from 'redux-api-middleware';
import endpoints from '../../utils/endpoints';
import { removeFavouriteAccountRequestBody, addFavouriteAccountRequestBody } from '../../helpers/apiRequestBuilder';
import { getBankId } from '../session/selectors';

export const GET_FAVOURITE_ACCOUNTS_REQUEST = 'GET_FAVOURITE_ACCOUNTS_REQUEST';
export const GET_FAVOURITE_ACCOUNTS_SUCCESS = 'GET_FAVOURITE_ACCOUNTS_SUCCESS';
export const GET_FAVOURITE_ACCOUNTS_FAILURE = 'GET_FAVOURITE_ACCOUNTS_FAILURE';

export const SET_FAVOURITE_REQUEST = 'SET_FAVOURITE_REQUEST';
export const SET_FAVOURITE_SUCCESS = 'SET_FAVOURITE_SUCCESS';
export const SET_FAVOURITE_FAILURE = 'SET_FAVOURITE_FAILURE';

export const UPDATE_REMOVE_FAVOURITE_ACCOUNT = 'UPDATE_REMOVE_FAVOURITE_ACCOUNT';
export const UPDATE_ADD_FAVOURITE_ACCOUNT = 'UPDATE_ADD_FAVOURITE_ACCOUNT';

export const getFavouriteAccounts = (bankId) => {
	const { method, x_bpi_version } = endpoints.getFavouriteAccounts;
	return {
		[RSAA]: {
			endpoint: endpoints.getFavouriteAccounts.resolve({ bankId }),
			method,
			types: [GET_FAVOURITE_ACCOUNTS_REQUEST, GET_FAVOURITE_ACCOUNTS_SUCCESS, GET_FAVOURITE_ACCOUNTS_FAILURE],
			headers: { 'x-bpi-version': x_bpi_version },
		},
	};
};

export const setFavouriteAccounts = (bankId, body) => {
	const { method, x_bpi_version } = endpoints.setFavouriteAccounts;
	return {
		[RSAA]: {
			endpoint: endpoints.setFavouriteAccounts.resolve({ bankId }),
			method,
			types: [SET_FAVOURITE_REQUEST, SET_FAVOURITE_SUCCESS, SET_FAVOURITE_FAILURE],
			headers: { 'x-bpi-version': x_bpi_version },
			body,
		},
	};
};

export const updateRemoveFavouriteAccount = (id) => ({
	type: UPDATE_REMOVE_FAVOURITE_ACCOUNT,
	id,
});

export const updateAddFavouriteAccount = (account) => ({
	type: UPDATE_ADD_FAVOURITE_ACCOUNT,
	account,
});

export const removeFavouriteAccount = (accountId) => (dispatch, getState) => {
	const state = getState();
	const bankId = getBankId(state);
	const body = removeFavouriteAccountRequestBody(accountId, state);
	return dispatch(setFavouriteAccounts(bankId, body)).then((response) => {
		if (response.type === SET_FAVOURITE_SUCCESS) {
			dispatch(updateRemoveFavouriteAccount(accountId));
		}
		return response;
	});
};
export const addFavouriteAccount = (account) => (dispatch, getState) => {
	const state = getState();
	const bankId = getBankId(state);
	const body = addFavouriteAccountRequestBody(account, state);
	return dispatch(setFavouriteAccounts(bankId, body)).then((response) => {
		if (response.type === SET_FAVOURITE_SUCCESS) {
			dispatch(updateAddFavouriteAccount(account));
		}
		return response;
	});
};
